var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationProvider',{ref:"validationProvider",attrs:{"name":_vm.validationProviderName,"rules":_vm.rules},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('v-select',{attrs:{"error-messages":errors,"label":_vm.label,"items":_vm.items},on:{"change":_vm.changed},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }